<template>
  <div class="tag-comp">
    <!-- layout="total, prev, pager, next, jumper" -->
    <el-pagination
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-size="currentPageSize"
      layout="total, prev, pager, next"
      :total="total"
      :style="{
        width: pagWidth,
      }"
    >
    </el-pagination>
  </div>
</template>

<script>
export default {
  props: {
    pagWidth: {
      // default: "600px",
    },
    total: {
      default: 1,
    },
    currentPage: {
      default: 1,
    },
    currentPageSize: Number,
  },
  data() {
    return {
      activeName: true,
    };
  },
  methods: {
    // 改变页数
    handleCurrentChange(val) {
      this.$emit("pagination", val);
    },
  },
};
</script>

<style lang="scss" scoped>
.tag-comp {
  // margin-bottom: 20px;
  // background-color: #ffffff;
  overflow: hidden;
  ::v-deep .bottom-section .el-tabs__header {
    margin-bottom: 0;
  }
  ::v-deep .el-pagination {
    float: right;
    // margin-top: 20px;
    .el-pagination__total {
      margin-right: 20pt;
    }
  }

  ::v-deep .el-pagination .btn-prev {
    background-color: transparent;
    color: #fff;
  }
  ::v-deep .el-pagination .btn-next {
    background-color: transparent;
    color: #fff;
  }

  ::v-deep .el-pagination button:disabled {
    background-color: #0000;
  }
  ::v-deep .el-pager li {
    background-color: #0000;
    color: #fff;
  }
  ::v-deep .el-pagination .el-pagination__total {
    background-color: #0000;
    color: #fff;
  }
  ::v-deep .el-pager li.active {
    color: #989898 !important;
  }

  ::v-deep .el-pager li:hover {
    color: #989898 !important;
  }
}
</style>
<style></style>
